import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import MessageItem from "../../Sav/NewTicketSav/ChatContainer/MessageItem";
import {
  createOrderComment,
  getOrderComments,
} from "../../../REDUX/actions/commandes";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { isDefined } from "../../../Utils";
import RichTextEditor from "../../RichTextEditor";

function Commentaires({ scrollableComment, setScrollableComment }) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const [isEditing, setIsEditing] = useState(false);
  const {
    commande: order,
    currentComments,
    currentCommentsLoading: loading,
  } = useSelector((state) => state.commandeReducer);
  const [newMessage, setNewMessage] = useState({ text: "", attachments: [] });

  const groupMessagesByDate = (messages) => {
    return messages?.reduce((acc, message) => {
      const createdAt = message?.attributes?.createdAt;
      const formattedDate = createdAt ? moment(createdAt).format("LL") : "-";

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(message);

      return acc;
    }, {});
  };

  const groupedMessages = useMemo(
    () => groupMessagesByDate(currentComments),
    [currentComments]
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "attachments") {
      setNewMessage({
        ...newMessage,
        [name]:
          newMessage?.attachments?.length > 0
            ? [...newMessage?.attachments, ...value]
            : value,
      });
    } else {
      setNewMessage({ ...newMessage, [name]: value });
    }
  };

  const handleSubmit = (e, callback) => {
    e.preventDefault();
    if (
      newMessage?.text?.trim()?.length > 0 ||
      newMessage?.attachments?.length > 0
    ) {
      dispatch(
        createOrderComment(
          newMessage,
          order?.id,
          user?.id,
          () => {
            setNewMessage({ text: "", attachments: [] });
            callback();
          },
          t
        )
      );
    }
  };

  useEffect(() => {
    if (order?.id) {
      dispatch(getOrderComments(order?.id));
    }
  }, [dispatch, order?.id]);

  useEffect(() => {
    if (isDefined(scrollableComment) && currentComments?.length > 0) {
      document
        .getElementById(scrollableComment)
        ?.scrollIntoView({ behavior: "smooth" });
      setScrollableComment();
    }
  }, [scrollableComment, currentComments, setScrollableComment]);

  return (
    <div className="ps-5 pe-3 pt-4 newSavComment d-flex flex-column justify-content-end max-w-600px mx-auto w-100">
      <div className="d-flex px-4 flex-column overflow-auto flex-column-reverse flex-grow-1 pt-3 pb-5">
        {Object.entries(groupedMessages).map(([date, messages]) => (
          <Fragment key={date}>
            {messages.map((comment, index) => (
              <MessageItem
                key={comment?.id}
                index={index}
                message={comment}
                isOwner={+user?.id === +comment?.attributes?.user?.data?.id}
                view="ORDER"
                position={index === 0 ? "bottom" : "top"}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
              />
            ))}

            <div className="text-center text-muted my-2 px-4 py-2 f11 bg-dimGrey br5 sBold d-flex fit-content mx-auto text-dark">
              {date}
            </div>
          </Fragment>
        ))}
      </div>
      <div className={"px-4"}>
        <RichTextEditor
          loading={loading}
          handleChange={handleChange}
          newMessage={newMessage}
          setNewMessage={setNewMessage}
          handleSubmit={handleSubmit}
        />
      </div>
    </div>
  );
}

export default Commentaires;
